// removed by extract-text-webpack-plugin
module.exports = {"logo":"src-components-logo----index-module---logo---3PlfJ","brandName":"src-components-logo----index-module---brandName---r2DHU","brandReinvent":"src-components-logo----index-module---brandReinvent---3fIuZ","brandSoftware":"src-components-logo----index-module---brandSoftware---2PrRa","image":"src-components-logo----index-module---image---MwEwY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/index.module.scss
// module id = 318
// module chunks = 114276838955818